module.exports = __webpack_public_path__ + "img/Speaker=Kaitlyn Barnett.4fc696f1.png";